const SCHEME_RE = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;

function stripControlChars(raw) {
  const value = String(raw ?? "");
  let out = "";
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if ((code >= 0 && code <= 31) || code === 127) continue;
    out += value[i];
  }
  return out;
}

function normalizeInput(raw) {
  return stripControlChars(raw).trim();
}

export function sanitizeExternalHttpUrl(raw) {
  const value = normalizeInput(raw);
  if (!value) return "";

  try {
    const parsed = new URL(value);
    if (!/^https?:$/i.test(parsed.protocol)) return "";
    return parsed.toString();
  } catch {
    return "";
  }
}

export function sanitizeLinkHref(raw, { allowRelative = true, allowMailto = true, allowTel = true, allowHash = true } = {}) {
  const value = normalizeInput(raw);
  if (!value) return "";

  if (allowMailto && /^mailto:/i.test(value)) return value;
  if (allowTel && /^tel:/i.test(value)) return value;
  if (allowHash && value.startsWith("#")) return value;

  const external = sanitizeExternalHttpUrl(value);
  if (external) return external;

  if (!allowRelative) return "";
  if (SCHEME_RE.test(value)) return "";
  if (/^(\/|\.\/|\.\.\/)/.test(value)) return value;
  return "";
}

export function openExternalUrl(raw) {
  if (typeof window === "undefined") return false;
  const safe = sanitizeExternalHttpUrl(raw);
  if (!safe) return false;
  window.open(safe, "_blank", "noopener,noreferrer");
  return true;
}

export function assignExternalUrl(raw) {
  if (typeof window === "undefined") return false;
  const safe = sanitizeExternalHttpUrl(raw);
  if (!safe) return false;
  window.location.href = safe;
  return true;
}
